var path = '/pages/guestlists/components/rsvp-relations/component.tpl.html';
var html = "<div class=\"data-list\">\n    <ul>\n        <li ng-repeat=\"relationType in vm.guestlist.rsvp_relation_types\">\n            <span class=\"data-label\">{{relationType.label}}</span>\n            <span class=\"data-value\">\n                <span ng-repeat=\"relation in vm.rsvp.relations[relationType.uuid]\"><a ui-sref=\"app.guestlists.rsvps.details({id: relation.id})\" target=\"_blank\">{{ relation.contact.data.full_name }} ({{ relation.code }})<br/></span>\n            </span>\n        </li>\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/components/rsvp-relations/component.tpl.html
// module id = 2255
// module chunks = 1